import styled from 'styled-components/macro';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { FrameInnerStyled, DeviceFrameBg, ImagePreview } from './styled';
export const TabletFrameInnerStyled = styled(FrameInnerStyled) `
  padding-top: 30px;
  width: 360px;

  ${ADAPTIVE.minWidth.tablet} {
    padding-top: initial;
    align-self: auto;
    height: 388px;

    ${({ isRightToLeft }) => isRightToLeft ? 'width: 318px; align-items: flex-end;' : 'width: 322px; align-self: unset;'}
  }

  ${ADAPTIVE.minWidth.desktop} {
    height: 507px;
    ${({ isRightToLeft }) => (isRightToLeft ? 'width: 395px;' : 'width: 427px;')}
  }
`;
export const TabletImagePreview = styled(ImagePreview) `
  ${ADAPTIVE.minWidth.tablet} {
    & > div {
      margin-top: 6px;
    }
  }

  & img {
    width: 360px;
    height: 464px;
    margin: 0 auto;
    border-radius: ${CORNER_RADIUS.m};

    ${ADAPTIVE.minWidth.tablet} {
      height: 387px;
      width: 272px;
    }

    ${ADAPTIVE.minWidth.desktop} {
      height: 506px;
      width: 360px;
    }
  }
`;
export const TabletDeviceFrameBg = styled(DeviceFrameBg) `
  width: 549px;
  background-position: 0 190px;
  margin-left: 46px;

  ${ADAPTIVE.minWidth.tablet} {
    background-position: 0 0px;
    margin-top: 100px;
    top: 0;
    height: 548px;

    ${({ isRightToLeft = false }) => isRightToLeft
    ? `
      width: 410px;
      margin-left: -6px`
    : `
      width: 390px;
      margin-left: -30px;
    `};
  }

  ${ADAPTIVE.minWidth.desktop} {
    background-position: center 28px;
    margin-top: 0;
    width: 582px;
    height: 720px;
    margin-left: -36px;
  }
`;
